import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { AutomationsTableComponent } from '@tv3/containers/automations/automations-table/automations-table.component'
import { AutomationTypes, AutomationViewGroup } from '@tokeet-frontend/automations'
import { DocumentAutomationOverlayService } from '@tv3/containers/documents/automations/automation-overlay/document-automation-overlay.service'

@Component({
  selector: 'app-document-automations',
  templateUrl: './document-automations.component.html',
  styleUrls: ['./document-automations.component.scss'],
})
export class DocumentAutomationsComponent implements OnInit {
  @ViewChild(AutomationsTableComponent) table: AutomationsTableComponent

  @Input() showActions = false

  @Input() viewType: 'list' | 'grid' = 'list'
  type = AutomationTypes.Document

  constructor(private documentAutomationOverlay: DocumentAutomationOverlayService) {}

  ngOnInit(): void {}

  onAdd() {
    this.documentAutomationOverlay.open()
  }

  onEdit(automation: AutomationViewGroup) {
    this.documentAutomationOverlay.open(automation)
  }

  onDuplicate(automation: AutomationViewGroup) {
    this.documentAutomationOverlay.open(automation, true)
  }
}
